import * as z from 'zod/mini'
import { userFields } from '../../schemas/user'

/** One user (`admin/users/:userId`). A malformed id is a 404, like an unknown one. */
export const adminUserParams = z.object({
  userId: z.uuid(),
})
export type AdminUserParams = z.infer<typeof adminUserParams>

/** Staff block an account (`POST admin/users/:userId/block`). The reason is for staff only. */
export const blockAdminUserBody = z.object({
  reason: z.optional(userFields.blockedReason),
})
export type BlockAdminUserBody = z.infer<typeof blockAdminUserBody>
